import moment from 'moment'
import * as Redux from 'redux'
import * as Image from '../../components/image'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const fetchPromotions: IsActive.FilteredFetcher = IsActive.filteredFetchAction(
  Constants.FETCH_PROMOTIONS,
  Constants.SERVER_RESOURCE,
)
export const fetchPromotionsByDate: any = IsActive.filteredDateFetchAction(
  Constants.FETCH_PROMOTIONS,
  Constants.SERVER_RESOURCE,
)

export interface EditPromotionAction extends Redux.Action {
  editType: string,
  promotion: Types.Promotion,
}
export const editModal = (promotion: Types.Promotion, editType: string): EditPromotionAction =>
  ({type: Constants.EDIT_PROMOTION, promotion, editType})

export const resetModal: Modal.Reset = Modal.resetModal(Constants.ADD_PROMOTION)
export const toggleModal: Modal.Toggle = Modal.toggleModal(Constants.ADD_PROMOTION)
export const updateModalField: Modal.Update = Modal.updateModal(Constants.ADD_PROMOTION)

const dateToDateString = (d: moment.Moment): string => {
  return (d && moment.isMoment(d)) ? d.toISOString().slice(0, 10) : null
}

const convertDates = (payload: any): any => {
  return {
    ...payload,
    end_date: dateToDateString(payload.end_date),
    start_date: dateToDateString(payload.start_date),
  }
}

export const create: Modal.Submit<Types.ModalData> = (community: string, data: Types.ModalData) =>
  Request.requestActionCreator(Constants.ADD_PROMOTION)({
    method: 'POST',
    payload: convertDates(data),
    url: `${Constants.SERVER_RESOURCE}/${community}`,
  })

export const update: Modal.Submit<Types.ModalData> = (community: string, data: Types.ModalData) =>
  Request.requestActionCreator(Constants.EDIT_PROMOTION)({
    method: 'PUT',
    payload: convertDates(data),
    url: `${Constants.SERVER_RESOURCE}/${community}/${data.id}`,
  })

export const statusUpdate = (community: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_PROMOTION)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Constants.SERVER_RESOURCE}/${community}/${stateChange.id}`,
  })

export const createOrUpdate = (community: string, data: Types.ModalData) =>
  data.id ? update(community, data) : create(community, data)

export const uploadImage = Image.uploadImage(Constants.UPLOAD_IMAGE_PROMOTION)



// WEBPACK FOOTER //
// ./src/pages/promotions/actions.ts